
import {
  Vue,
  Component,
  Prop,
  Model,
  Ref,
  Watch,
} from "vue-property-decorator";
import { BgDialog } from "@banggood/scm-fe";
import { CascaderPanel } from "element-ui";
import { getAllNewCategoryTree } from "@/service/supplier-meta/api/index";
import { NewCategory } from "@/service/product/entity/NewCategory";
import cloneDeep from "lodash/cloneDeep";
interface FilterOption {
  value: string[];
  label: string;
  subLabel: string;
}
@Component({
  components: {
    BgDialog,
  },
})
export default class CategoryPicker extends Vue {
  @Prop({ required: false, default: "选择品类" }) title?: string;
  @Prop({ required: false, default: true }) checkStrictly?: boolean;
  @Prop() visible!: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ required: false, default: false }) multiple?: boolean;
  @Prop({ required: false }) optionsFilter?: (
    options: NewCategory[]
  ) => NewCategory[];
  @Model("change", { type: Array, required: false }) readonly value?:
    | string[]
    | string[][];
  @Ref() cascaderPanel!: CascaderPanel;

  cascaderValue: string[] | Array<string[]> = [];
  optionClicked = false;
  separator = " > ";
  labelField = "";
  filteredOptions: FilterOption[] = [];
  labelFieldOptions: string[] = [];
  keyword = "";
  options: NewCategory[] = [];
  loading = false;
  categoryData: NewCategory[] = [];
  get props() {
    return {
      label: ["cname", "ename"],
      value: "id",
      children: "subs",
      checkStrictly: this.checkStrictly,
      expandTrigger: "click",
    };
  }
  get finalLabelField() {
    return this.labelField || this.labelFieldOptions[0] || "";
  }
  get isChangeLabelBtnVisible() {
    return Array.isArray(this.props?.label) && this.props?.label.length;
  }
  get cascaderProps() {
    return {
      ...this.props,
      label: this.labelField,
      multiple: this.multiple,
    };
  }
  @Watch("visible", { immediate: true })
  async handleVisibleChange(val: boolean) {
    if (val) {
      if (this.options.length === 0 && !this.loading) {
        this.loading = true;
        const options = await this.getOptions();
        this.loading = false;
        this.categoryData = options;
        if (typeof this.optionsFilter === "function") {
          this.options = this.optionsFilter(options);
        }
      }
      console.log("this.value", this.value);
      if (this.value !== undefined) {
        this.cascaderValue = this.value;
      } else {
        this.cascaderValue = [];
      }
    }
  }
  created() {
    this.intLabelField();
    this.getOptionsFromCache();
  }
  async getOptions() {
    const options = this.getOptionsFromCache();
    if (Array.isArray(options) && options.length) {
      return options;
    } else {
      const res = await getAllNewCategoryTree();
      if (res.isSuccess && Array.isArray(res.result)) {
        const options = res.result;
        this.saveOptionsToCache(options);
        return options;
      }
      return [];
    }
  }
  saveOptionsToCache(options: NewCategory[]) {
    const optionsStr = JSON.stringify(options);
    try {
      sessionStorage.setItem("supplierSystem_newCategory", optionsStr);
    } catch (err) {
      console.log(err);
    }
  }
  getOptionsFromCache(): NewCategory[] {
    let options: NewCategory[] = [];
    try {
      const optionsStr = sessionStorage.getItem("supplierSystem_newCategory");
      if (optionsStr) {
        options = JSON.parse(optionsStr);
      }
    } catch (err) {
      console.log(err);
    }
    return options;
  }
  intLabelField() {
    if (Array.isArray(this.props.label)) {
      this.labelField = this.props.label[0];
      this.labelFieldOptions = [...this.props.label, ""];
    } else {
      this.labelField = this.props.label || "";
    }
  }
  handleKeywordInput(val: string) {
    this.filteredOptions = this.filter(val, this.options);
  }
  changeLabel() {
    const labels = this.labelFieldOptions;
    if (Array.isArray(labels) && labels.length > 1) {
      const curIndex = labels.findIndex((ele) => ele === this.labelField);
      if (curIndex === labels.length - 1) {
        this.labelField = labels[0];
      } else {
        this.labelField = labels[curIndex + 1];
      }
    }
  }
  filter(
    kw: string,
    options: NewCategory[],
    paths?: {
      label: string[];
      subLabel?: string[];
      value: string[];
    }
  ) {
    let res: FilterOption[] = [];
    if (kw) {
      //
      const labelField = this.labelField;
      const valueField = this.props.value;
      const childrenField = this.props.children;
      const isSubLabel = !labelField && this.labelFieldOptions.length === 3;
      const subLabelField = this.labelFieldOptions[1];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (options as any[]).forEach((ele) => {
        const newLabelPath = (
          Array.isArray(paths?.label)
            ? paths?.label.concat(ele[this.finalLabelField])
            : [ele[this.finalLabelField]]
        ) as string[];
        const newSubLabelPath =
          Array.isArray(paths?.subLabel) && isSubLabel
            ? paths?.subLabel.concat(ele[subLabelField])
            : [ele[subLabelField]];
        const newValuePath = (
          Array.isArray(paths?.value)
            ? paths?.value.concat(ele[valueField])
            : [ele[valueField]]
        ) as string[];
        const match = labelField
          ? ele[labelField].indexOf(kw) >= 0
          : ele[this.labelFieldOptions[0]].indexOf(kw) >= 0 ||
            ele[this.labelFieldOptions[1]].indexOf(kw) >= 0;
        if (match) {
          res.push({
            label: newLabelPath?.join(this.separator) || "",
            subLabel: isSubLabel
              ? paths?.subLabel
                  ?.concat(ele[subLabelField])
                  .join(this.separator) || ""
              : "",
            value: newValuePath || [],
          });
        }
        if (Array.isArray(ele[childrenField])) {
          res = res.concat(
            this.filter(kw, ele[childrenField], {
              label: newLabelPath,
              subLabel: newSubLabelPath,
              value: newValuePath,
            })
          );
        }
      });
    }
    return res;
  }
  handleCascaderValueChange(val: string[] | Array<string[]>) {
    this.$emit("change", val);
  }
  selectFilteredOption(fOption: FilterOption) {
    this.keyword = "";
    if (this.multiple) {
      const isReadySelected = (this.cascaderValue as string[][]).some(
        (val) => JSON.stringify(val) === JSON.stringify(fOption.value)
      );
      if (!isReadySelected) {
        const newSelected = fOption.value as string[];
        (this.cascaderValue as string[][]).push(newSelected);
      }
    } else {
      this.cascaderValue = fOption.value;
    }
    this.handleCascaderValueChange(this.cascaderValue);
  }
  async sure() {
    await this.done();
    this.close();
  }
  async done() {
    this.keyword = "";
    return new Promise((resolve) => {
      this.$nextTick(() => {
        let value = cloneDeep(this.cascaderValue);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const selectedNodes = (this.cascaderPanel as any).getCheckedNodes();
        this.$emit("done", value, selectedNodes);
        resolve(value);
      });
    });
  }
  reset() {
    this.keyword = "";
    this.cascaderValue = [];
  }
  close() {
    this.reset();
    this.$emit("update:visible", false);
    this.$emit("close");
  }
}
